<template>
	<div>
		<router-view v-show="$route.matched.length == 3"></router-view>
		<div id="auditTop" class="main-page-content" v-show="$route.matched.length == 2">
			<PageHeaderLayout>
				<div style="background: #fff; padding: 20px 20px">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item label="公司名称">
							<el-input class="company_input" placeholder="请输入公司名称" v-model="searchCondition.company_name" clearable></el-input>
						</el-form-item>
						<el-form-item label="税源地" class="tax-source-form-item">
							<ScreeCompany :allowField="allowField" @ScreeCompany="ScreeCompany" />
						</el-form-item>
						<el-form-item label="状态">
							<el-select clearable v-model="searchCondition.examine_status" placeholder="审核状态">
								<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="时间">
							<DatePicker @dataSearch="dataSearch" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
						</el-form-item>
					</el-form>
					<div style="margin: 0 20px">
						<el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#fbfbfb' }">
							<el-table-column prop="id" label="编号" align="center"></el-table-column>
							<el-table-column prop="company.name" label="公司名称" align="center" v-if="activeName === '1'"></el-table-column>
							<el-table-column v-else prop="company_name" label="公司名称" align="center"></el-table-column>
							<el-table-column prop="channel_account" label="税源地名称" width="180" align="center"></el-table-column>
							<el-table-column prop="category_name" label="任务类型" align="center"></el-table-column>
							<el-table-column prop="created_at" label="提交时间" align="center"></el-table-column>
							<el-table-column prop="mission_content" label="任务描述" align="center">
								<template slot-scope="scope">
									<div v-if="scope.row.mission_content !== ''">
										<el-button type="text" @click="taskseeClick(scope.row)">查看</el-button>
									</div>
									<div v-else>-</div>
								</template>
							</el-table-column>
							<el-table-column prop="examine_status" label="状态" align="center">
								<template slot-scope="scope">
									{{ scope.row.examine_status == '0' ? '审核中' : scope.row.examine_status == '1' ? '审核成功' : scope.row.examine_status == '2' ? '审核失败' : '' }}
								</template>
							</el-table-column>
							<el-table-column label="操作" align="center" width="220">
								<template slot-scope="scope">
									<el-button v-if="scope.row.examine_status == '0'" size="mini" type="primary" @click="examineClick(scope.row)">审核</el-button>
									<el-button style="margin-left: 8px" size="mini" type="primary" @click="personClick(scope.row)">人员列表</el-button>
									<el-button style="margin-left: 8px" size="mini" @click="taskClick(scope.row)">详情</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
		
				<el-dialog title="任务描述" :visible.sync="taskseedialogVisible" width="30%">
					<div>
						{{ mission_content }}
					</div>
					<div style="text-align: center; margin-top: 20px">
						<span slot="footer" class="dialog-footer">
							<el-button @click="taskseedialogVisible = false" size="mini" type="primary">确 认</el-button>
						</span>
					</div>
				</el-dialog>
				<el-dialog title="" :visible.sync="examinedialogVisible" width="50%">
					<el-radio-group v-model="radio">
						<el-radio :label="1">审核通过</el-radio>
						<el-radio :label="2">审核拒绝</el-radio>
					</el-radio-group>
					<div v-if="radio == 2" style="margin-top: 30px">
						<el-form :model="userList" label-width="90px" :rules="userRules" ref="userRef">
							<el-form-item prop="textarea">
								<el-input type="textarea" placeholder="请输入内容" v-model="userList.textarea" maxlength="100" show-word-limit :rows="5"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="examinedialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="userInfo">确 定</el-button>
					</span>
				</el-dialog>
		
				<el-pagination
					style="float: right"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page.sync="pagege.current_page"
					:page-sizes="[10, 20, 50, 100]"
					:page-size="pagege.page_size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pagege.total"
				></el-pagination>
			</PageHeaderLayout>
		</div>
	</div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue';
import PageHeaderLayout from '@/layouts/PageHeaderLayout';
import ScreeCompany from '@/components/ScreeCompany.vue';
export default {
	components: {
		DatePicker,
		PageHeaderLayout,
		ScreeCompany
	},
	data() {
		var checkName = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入失败原因!'));
			} else {
				callback();
			}
		};
		return {
			activeName: '1',
			allowField: ['settlementId'],
			options: [
				{
					value: '0',
					label: '审核中'
				},
				{
					value: '1',
					label: '审核成功'
				},
				{
					value: '2',
					label: '审核失败'
				}
			],
			searchCondition: {},
			pagege: {},
			id: '',
			mission_content: '',

			userList: {
				textarea: ''
			},
			radio: 1,
			examinedialogVisible: false,
			taskseedialogVisible: false,
			tableData: [],
			ispage: 1,
			num: 10,
			userRules: {
				textarea: [{ required: true, validator: checkName, trigger: 'blur' }]
			}
		};
	},
	created() {
		this.init();
	},

	methods: {
		// 搜索
		searchButton() {
			this.ispage = 1;
			this.init();
		},
		ScreeCompany(v, name) {
			if (name == 'settlement') {
				if (v) {
					this.searchCondition.channel_account = v;
				} else {
					delete this.searchCondition.channel_account;
				}
			}
		},
		//获取选中日期的值
		dataSearch(value) {
			this.searchCondition.time = {};
			this.searchCondition.time.start_time = value[0];
			this.searchCondition.time.end_time = value[1];
		},
		handleSizeChange(val) {
			this.num = val;
			this.ispage = 1;
		},
		handleCurrentChange(val) {
			this.ispage = val;
			this.init();
		},
		personClick(row){
			if (this.activeName === '1') {
				this.$router.push({ path: '/Taskaudit/privatePersonnelList', query: { id: row.id } });
			} else {
				this.$router.push({ path: '/Taskaudit/personnelList', query: { id: row.id } });
			}
		},
		//详情
		taskClick(row) {
			this.$router.push({ path: '/taskdetail', query: { id: row.id, active: this.activeName } });
		},
		async init() {
			let objects = {
				current_page: this.ispage,
				page_size: this.num,
				examine_status: this.searchCondition.examine_status,
				company_name: this.searchCondition.company_name,
				channel_account: this.searchCondition.channel_account,
				time: this.searchCondition.time
			};
			let res = {};
			if (this.activeName === '1') {
				res = await this.$api.posttask(objects);
			} else {
				res = await this.$api.postDaily_taskList(objects);
			}
			let { data, pages } = res;
			this.tableData = data;
			this.pagege = pages;
		},

		taskseeClick(row) {
			this.mission_content = row.mission_content || row.job_remark;
			this.taskseedialogVisible = true;
		},
		examineClick(row) {
			this.id = row.id;
			this.radio = 1;
			this.userList.textarea = '';
			this.examinedialogVisible = true;
		},
		async userInfo() {
			let obj = {
				examine_status: this.radio,
				examine_reason: this.userList.textarea
			};

			if (obj.examine_status == 2 && obj.examine_reason == '') {
				this.$message.error('请填写拒绝理由');
			} else {
				let Status = '';
				if (this.activeName === '1') {
					Status = await this.$api.postStatus(this.id, obj);
				} else {
					Status = await this.$api.postDaily_taskExamine(this.id, obj);
				}
				this.$nextTick(() => {
					if (Status) {
						this.$message.success('审核成功!');
						this.init();
						this.examinedialogVisible = false;
					}
				});
			}
		}
	}
};
</script>

<style scoped lang="scss">
.main-page-content {
	padding-bottom: 50px;
}

.tax-source-form-item /deep/ .settlement {
	margin-right: 0;
}

.tax-source-form-item /deep/ .el-input__inner {
	height: 32px;
	line-height: none;
}
</style>
